<template lang="html">
  <div>
  <vs-list>
    <!-- <vs-list-header title="Payment Accepted"></vs-list-header> -->
    <vs-list-item v-if="gateway.stripe" title="Stripe" subtitle="Allow you to charge your customer by credit card directly and add into your preset stripe account. QuickSend will be able to see your account data (such as all payment and payout history), including any data created by other platforms you've connected. They'll also be able to create new payments and take other actions for you.">
      <vs-button color="primary" size="small" type="filled" @click.stop="integrateStripe" v-if="stripe_switch==null">Integrate</vs-button>
      <vs-switch color="success" v-model="stripe_switch" v-if="stripe_switch!=null">
      <span slot="on">Active</span>
      <span slot="off">inactive</span>
      </vs-switch>
    </vs-list-item>

    <vs-list-item v-if="gateway.quicksendpay" title="QuickSend Pay" subtitle="QuickSend Pay is a payment feature where QuickSend will require the buyer to pay upfront for the orders they make and release the payment to you (seller) once your buyer completed their order. Once the item is being delivered, buyer will be given 3 days to check the item and request for refund if needed.">
      <vs-button color="primary" size="small" type="filled" @click.stop="popupQSPay=true" v-if="qspay_switch==null">Integrate</vs-button>
      <vs-switch color="success" v-model="qspay_switch" v-if="qspay_switch!=null">
      <span slot="on">Active</span>
      <span slot="off">inactive</span>
      </vs-switch>  
      <vs-button color="primary" size="small" type="filled" @click.stop="popupViewQSPay=true" v-if="qspay_switch!=null">View</vs-button>
    </vs-list-item>

    <vs-list-item v-if="gateway.cod" title="Cash on Delivery (COD)" subtitle="Cash on delivery is a payment term that indicates that payment for the order is collected when the products are delivered to the customer.">
      <vs-button color="primary" size="small" type="filled" @click.stop="popupCOD=true" v-if="cod_switch==null">Activate</vs-button>
      <vs-switch color="success" v-model="cod_switch" v-if="cod_switch!=null">
      <span slot="on">Active</span>
      <span slot="off">inactive</span>
      </vs-switch>
      <vs-button color="primary" size="small" type="filled" @click.stop="popupViewCOD=true" v-if="cod_switch!=null">View</vs-button>
    </vs-list-item>

    <vs-list-item v-if="gateway.fpx" title="FPX Bank" subtitle="FPX Bank">
      <vs-button color="primary" size="small" type="filled" @click.stop="integrateFPX" v-if="fpx_switch==null">Activate</vs-button>
      <vs-switch color="success" v-model="fpx_switch" v-if="fpx_switch!=null">
      <span slot="on">Active</span>
      <span slot="off">inactive</span>
      </vs-switch>
    </vs-list-item>

    <!-- <vs-list-header title="Offline Payment"></vs-list-header>
    <vs-list-item >
      Payment through bankin. 
      <br>
      <vs-button color="primary" type="filled" @click.stop="integrateStripe" v-if="stripe_switch==null">Activate</vs-button>
      <vs-switch color="success" v-model="offline_switch" v-if="offline_switch!=null">
      <span slot="on">Active</span>
      <span slot="off">inactive</span>
      </vs-switch>
    </vs-list-item> -->
  </vs-list>

  <!-- popup quicksendpay creditcard-->
  <div class="centerx" style="width:100%;">
    <vs-popup title="Fill in bank details" :active.sync="popupQSPay">
      <p>
        Kindly fill in your bank account details for future money release.
      </p>
      <table style="width:100%;">
        <tr>
          <td>
            <vs-select v-model="bank" label="Bank" autocomplete  style="width:100%;">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="item,index in banklist" />
            </vs-select>
          </td>
        </tr>

        <tr>
          <td><vs-input class="inputx" label="Account No." placeholder="Bank Account No." v-model="bankacc"  style="width:100%;"/></td>
        </tr>
        <tr class="text-right">
          <td><vs-button color="primary" type="filled" @click="integrateQSPay"  style="width:100%; padding-top: 10px">Submit</vs-button></td>
        </tr>
      </table>
      <vs-popup title="Confirmation" :active.sync="popupConfirmQSPay">
        <p>
          Kindly confirm the details are correct.
        </p>
        <table style="width:100%;">
          <tr>
            <td><vs-input class="inputx" label="Bank" disabled v-model="bank"  style="width:100%;"/></td>
          </tr>

          <tr>
            <td><vs-input class="inputx" label="Account No." disabled v-model="bankacc" style="width:100%;"/></td>
          </tr>
          <tr class="text-right">
            <td>
              <vs-button color="primary" type="filled" @click="popupConfirmQSPay=false">No</vs-button>
              <vs-button color="primary" type="filled" @click="integrateQSPay(1)">Yes</vs-button>
            </td>
          </tr>
        </table>
      </vs-popup>
    </vs-popup>
    <vs-popup title="Bank Details" :active.sync="popupViewQSPay">
      <table style="width:100%;">
        <tr>
          <td><vs-input class="inputx" label="Bank" disabled v-model="bank"  style="width:100%;"/></td>
        </tr>

        <tr>
          <td><vs-input class="inputx" label="Account No." disabled v-model="bankacc" style="width:100%;"/></td>
        </tr>
        <tr class="text-right">
          <td>
            <vs-button color="primary" type="filled" @click="popupViewQSPay=false">Close</vs-button>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>

  <!-- popup cod-->
  <div class="centerx" style="width:100%;">
    <vs-popup title="Fill in COD details" :active.sync="popupCOD">
      <p>
        Kindly fill in your COD instruction details
      </p>
      <table style="width:100%;">
        <tr>
          <td>
            <vs-textarea label="Instruction" v-model="codRemark" style="width:auto;"/>
          </td>
        </tr>
        <tr class="text-right">
          <td>
            <vs-button color="primary" type="filled" @click="integrateCOD" style="padding-top: 10px">Submit</vs-button>
          </td>
        </tr>
      </table>
      <vs-popup title="Confirmation" :active.sync="popupConfirmCOD">
        <p>
          Kindly confirm the details are correct.
        </p>
        <table style="width:100%;">
          <tr>
            <td><vs-textarea label="Instruction" v-model="codRemark" disabled style="width:auto;"/></td>
          </tr>
          <tr>
            <td class="text-right">
              <vs-button color="primary" type="filled" @click="popupCOD=false">No</vs-button>
              <vs-button color="primary" type="filled" @click="integrateCOD(1)">Yes</vs-button>
            </td>
          </tr>
        </table>
      </vs-popup>
    </vs-popup>
    <vs-popup title="COD instruction details" :active.sync="popupViewCOD">
      <table style="width:100%;">
        <tr>
          <td><vs-textarea label="Instruction" v-model="codRemark" disabled style="width:auto;"/></td>
        </tr>
        <tr>
          <td class="text-right">
            <vs-button color="primary" type="filled" @click="popupViewCOD=false">Close</vs-button>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      gateway : {
        stripe:false,
        quicksendpay:false,
        cod:false,
        fpx:false
      },
      stripe_switch:null,
      cod_switch:null,
      qspay_switch:null,
      fpx_switch:null,
      stripe_payment_gateway_id:null,
      cod_payment_gateway_id:null,
      qspay_payment_gateway_id:null,
      fpx_payment_gateway_id:null,
      popupQSPay : false,
      popupConfirmQSPay : false,
      popupViewQSPay : false,
      bank:0,
      bankacc:'',
      banklist:[],
      popupCOD : false,
      popupConfirmCOD : false,
      popupViewCOD : false,
      codRemark:''
    }
  },
  watch: {
    stripe_switch(newValue){
      //called whenever stripe_switch changes
      let status = (newValue) ? 1 : 0;
      this.toggleStatus({payment_gateway_id:this.stripe_payment_gateway_id,status:status});
    },
    cod_switch(newValue){
      //called whenever cod_switch changes
      let status = (newValue) ? 1 : 0;
      this.toggleStatus({payment_gateway_id:this.cod_payment_gateway_id,status:status});
    },
    qspay_switch(newValue){
      //called whenever qspay_switch changes
      let status = (newValue) ? 1 : 0;
      this.toggleStatus({payment_gateway_id:this.qspay_payment_gateway_id,status:status});
    },
    fpx_switch(newValue){
      console.log(newValue);
      //called whenever fpx_switch changes
      let status = (newValue) ? 1 : 0;
      this.toggleStatus({payment_gateway_id:this.fpx_payment_gateway_id,status:status});
    },
    banklist: function () { //detect inv_popup close event
      this.bank=this.banklist[0].name;
    }
  },
  computed: {
  },
  methods: {
    async integrateStripe(){
      let callback_payload = {
        email: this.$store.state.user.email,
        user_id: this.$store.state.user.id,
        organization_id: this.$store.state.user.current_organization,
      }
      await this.$store.dispatch('organization/integrateStripe',callback_payload)
      .then(async function(stripe) {
        if(typeof stripe.url !== 'undefined'){
          window.open(stripe.url,'_self');
          this.assign();
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    async integrateCOD(trigger=0){
      if(trigger===1){
        this.popupCOD=false;
        this.popupConfirmCOD=false;
        let callback_payload = {
          email: this.$store.state.user.email,
          user_id: this.$store.state.user.id,
          organization_id: this.$store.state.user.current_organization,
          remarks: this.codRemark,
        }
        let a = await this.$store.dispatch('organization/integrateCOD',callback_payload)
        if(a.id != null){
          this.assign();
        }
      }else{
        this.popupConfirmCOD=true;
      }
    },
    async integrateQSPay(trigger=0){
      if(trigger===1){
        this.popupQSPay=false;
        this.popupConfirmQSPay=false;
        let callback_payload = {
          email: this.$store.state.user.email,
          user_id: this.$store.state.user.id,
          organization_id: this.$store.state.user.current_organization,
          bank: this.bank,
          account_no: this.bankacc,
        }
        let result = await this.$store.dispatch('organization/integrateQSPay',callback_payload)
        this.assign();
      }else{
        this.popupConfirmQSPay=true;
      }
    },
    async integrateFPX(){
      let callback_payload = {
        email: this.$store.state.user.email,
        user_id: this.$store.state.user.id,
        organization_id: this.$store.state.user.current_organization,
      }
      let result = await this.$store.dispatch('organization/integrateFPX',callback_payload)
      this.assign();
    },
    async init(){
      let gatewaylist = [];
      if((this.$store.state.organization.payment_gateway).length > 0){
         console.log('got gatewaylist')
        gatewaylist = this.$store.state.organization.payment_gateway;
      }else{
         console.log('go get gatewaylist')
        gatewaylist = await this.$store.dispatch('organization/getPaymentGateway');
      }
      for(let a in gatewaylist){
        console.log('wow');
        console.log(gatewaylist[a])
        //assign based on method available
        if(gatewaylist[a]['id'] == 3){ // stripe integration
          this.gateway.stripe = true;
        }else if(gatewaylist[a]['id'] == 2){ // cod
          this.gateway.cod = true;
        }else if(gatewaylist[a]['id'] == 4){ //qspay
          this.gateway.quicksendpay = true;
        }else if(gatewaylist[a]['id'] == 5){ //stripefpx
          this.gateway.fpx = true;
        }
      }
      console.log('gatewaylist')
      console.log(gatewaylist)
    },
    async assign(){
    let methods = await this.$store.dispatch('organization/getOrganizationPaymentGateway',this.$store.state.user.current_organization);
      console.log(methods);
      for(let a in methods){
        //assign based on method available
        if(methods[a]['payment_gateway_id'] == 3){ // stripe integration
          if(methods[a]['status'] == 1){
            this.stripe_switch = true;
          }else if(methods[a]['status'] == 0){
            this.stripe_switch = false;
          }
          this.stripe_payment_gateway_id = methods[a]['payment_gateway_id'];
        }else if(methods[a]['payment_gateway_id'] == 2){ // cod
          this.cod_switch = (methods[a]['status'] == 1) ? true : false;
          this.cod_payment_gateway_id = methods[a]['payment_gateway_id'];
          let api_field_values = JSON.parse(methods[a]['api_field_values']);
          this.codRemark = api_field_values.remarks || '';
        }else if(methods[a]['payment_gateway_id'] == 4){ //qspay
          if(methods[a]['status'] == 1){
            this.qspay_switch = true;
          }else if(methods[a]['status'] == 0){
            this.qspay_switch = false;
          }
          this.qspay_payment_gateway_id = methods[a]['payment_gateway_id'];
          let api_field_values = JSON.parse(methods[a]['api_field_values']);
          this.bank = api_field_values.bank;
          this.bankacc = api_field_values.account_no;
        }else if(methods[a]['payment_gateway_id'] == 5){ // fpx
          this.fpx_switch = (methods[a]['status'] == 1) ? true : false;
          this.fpx_payment_gateway_id = methods[a]['payment_gateway_id'];
        }
      }
    },
    async toggleStatus(data){
      this.isMounted = false;
      await this.$store.dispatch('organization/togglePaymentGatewayStatus',
        {organization_id:this.$store.state.user.current_organization,payment_gateway_id:data.payment_gateway_id,status:data.status});
    }
  },
  async created () {
    this.init();
    this.assign();
    this.banklist = await this.$store.dispatch('organization/BankList');
  }
}
</script>

<style>
.list-titles {
  padding: 10px;
}
</style>

